<template>
	<Timeline class="study-wrap">
		 
			 

			<transition-group name="slide-up" v-if="kckjlist.length > 0">
				<div  v-for="item1 in kckjlist" :key="item1.id">
					 <div >
						<div class="study-body">
							<div class="study-item" style="margin-left: 0px;">
								<div class="name">{{ item1.title }}</div>

								<div class="action"  >
								<a :href="item1.dl_adr"><Button type="primary" shape="circle" long>打开资料</Button></a>
								</div>
								 
							</div>
						</div>
					</div>

				</div>
			</transition-group>
		 
	</Timeline>
</template>
<script>
	import {
		getCourseList,
		getCourseDetail,
		getQuestionByCid,
		
		studyList,
		updateVideo,
		accessStatistical,
		updateRecord,
		getCourseRecordList
	} from "../../api/api";
	export default {
		props: {
			// ucid: {
			// 	type: Number,

			// },
			kckjlist:{
				type:Array,
				},
		},
		data() {
			return {
				ulista: [],
				specialList: [],
				 
			};
		},

		mounted() {
			 
		 
			 

		},
		computed:{
			 
			 
		},
		methods: {
			 setVisible(item) {
				item.visible = !item.visible;
			},
			setnot() {
				return false;
			},
			 
			
		},
	};
</script>
<style lang="less" scoped>
	.study-wrap {
		padding: 0 10px;

		.item-dot {
			width: 15px;
			height: 15px;
			border-radius: 15px;
			border: 1px solid #ddd;
			display: inline-flex;
			align-items: center;
			justify-content: center;

			span {
				width: 7px;
				height: 7px;
				border-radius: 7px;
				background: #eee;
			}
		}

		/deep/.ivu-timeline-item-tail {
			border: 1px dashed #ddd;
		}
	}

	.study-title {
		margin-top: -6px;
		border-bottom: 1px solid #eee;
		display: flex;
		align-items: center;
		padding-bottom: 16px;
		cursor: pointer;

		.title-icon {
			margin-right: 16px;
		}

		.title-text {
			font-size: 20px;
		}
	}

	.study-body {
		.study-item {
			display: flex;
			align-items: center;
			border-bottom: 1px dashed #ddd;
			margin-left: 40px;
			padding: 16px 0;
justify-content: space-between;
			.name {
				width: 530px;
				font-size: 16px;
				color: #666;
				margin-right: 30px;
				// .ellipsis();
			}

			.progress {
				flex: 1;
				display: flex;
				align-items: center;

				&-title {
					font-size: 16px;
					color: #666;
					margin-right: 10px;
				}

				&-bar {
					width: 200px;
					margin-right: 10px;
				}

				&-text {
					flex: 1;
					font-size: 16px;
					color: #666;
				}
			}

			.action {
				width: 100px;
			}
		}
	}
</style>
